import { render, staticRenderFns } from "./CustomerCallSheets.vue?vue&type=template&id=fa9890f0&scoped=true&"
import script from "./CustomerCallSheets.vue?vue&type=script&lang=ts&"
export * from "./CustomerCallSheets.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerCallSheets.vue?vue&type=style&index=0&id=fa9890f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa9890f0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
